module.exports = __webpack_public_path__ + "front/img/kv06.5e1441e1.png";